import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// Paths
import { Flask } from './IconPaths';

const DEBUG = false;
const NUM_BUBBLES = 5;

class FlaskIcon extends React.Component {
  constructor(props) {
    super(props);

    this._bubbles = [];
    this._icon = null;
    this._motionPaths = _.times(NUM_BUBBLES, () => null);
  }
  _initAnimations() {

    const startShape = this._icon.querySelector('#liquid-1');
    const endShape = this._icon.querySelector('#liquid-2');

    const startPathData = startShape.getAttribute('d');
    const endPathData = endShape.getAttribute('d');

    TweenMax.to(startShape, 1, {
      morphSVG: endPathData,
      // ease: Power2.easeInOut,
      repeat: -1,
      yoyo: true,
      force3D: true
    });

    _.times(NUM_BUBBLES, i => {
      const bezierData = MorphSVGPlugin.pathDataToBezier(this._motionPaths[i], {
        align: this._bubbles[i]
      });
      TweenMax.set(this._bubbles[i], { xPercent: -50, yPercent: -50 });
      TweenMax.to(this._bubbles[i], 2, {
        opacity: 0,
        bezier: {
          values: bezierData,
          type: 'cubic'
        },
        ease: Linear.easeNone,
        repeat: -1,
        yoyo: false,
        delay: 0.4 * i
      });
    });

  }
  componentDidMount() {
    this._initAnimations();
  }
  render() {
    const { colors, height, width } = this.props;
    const baseIconColor = colors.length > 1 ? colors[1] : colors[0];
    const bubbleColor = colors[0];
    return (
      <svg viewBox='0 0 100 100' width={width} height={height}>
        <g ref={icon => { this._icon = icon; }}>
          <Flask transform={'translate(0, 20)'} liquidColor={baseIconColor} />
        </g>
        <g>
          {_.times(NUM_BUBBLES, i => (
            <circle
              key={`bubble-${i}`}
              ref={bubble => { this._bubbles[i] = bubble; }}
              cx={0}
              cy={0}
              r={NUM_BUBBLES - i}
              fill={bubbleColor}
              stroke='white' />
          ))}
        </g>
        {_.times(NUM_BUBBLES, i => {
          const stretchfactor = 20 * i / NUM_BUBBLES;
          return (
            <path
              key={`motionPath-${i}`}
              ref={motionPath => { this._motionPaths[i] = motionPath; }}
              d={`M 50,75 C ${50 - stretchfactor},50 ${50 + stretchfactor},25 50,5`}
              stroke={DEBUG ? 'cornflowerblue' : 'none'}
              fill='none' />
          );
        })}
      </svg>
    );
  }
};

FlaskIcon.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.string),
  width: PropTypes.number,
  height: PropTypes.number
};

FlaskIcon.defaultProps = {
  colors: ['black'],
  width: 200,
  height: 200
};

export default FlaskIcon;



// WEBPACK FOOTER //
// ./src/components/AnimatedIcons/FlaskIcon.jsx